import _ from "lodash";
import { RefObject, createContext } from "react";

interface IOptionMenuItemsContext {
  registerMenuItem: (ref: RefObject<HTMLButtonElement>) => void;
  unregisterMenuItem: (ref: RefObject<HTMLButtonElement>) => void;
  menuRef: RefObject<HTMLElement>;
}

/**
 * Context used for registering and unregistering menu items.
 */
const OptionMenuItemsContext = createContext<IOptionMenuItemsContext>({
  registerMenuItem: _.noop,
  unregisterMenuItem: _.noop,
} as IOptionMenuItemsContext);

export { IOptionMenuItemsContext, OptionMenuItemsContext };
